import { useState } from "react";
import { toast } from "sonner";
import { FileCheck2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { openBlob, formatApiError } from "@/lib/api";

export const CoiDialog = ({ policy }) => {
  const [holder, setHolder] = useState("");
  const [address, setAddress] = useState("");
  const [details, setDetails] = useState("");
  const path = () => `/policies/${policy.id}/coi.pdf?holder=${encodeURIComponent(holder)}&address=${encodeURIComponent(address)}&details=${encodeURIComponent(details)}`;
  const go = (download) => openBlob(path(), `certificate-${policy.policy_number}.pdf`, download).catch((e) => toast.error(formatApiError(e)));
  if (policy.status !== "active") return null;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="coi-open-btn"><FileCheck2 className="mr-2 h-4 w-4" /> Certificate of insurance</Button>
      </DialogTrigger>
      <DialogContent data-testid="coi-dialog">
        <DialogHeader>
          <DialogTitle>Certificate of insurance</DialogTitle>
          <DialogDescription>Create proof of coverage for a client, landlord, lender or general contractor.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <div className="space-y-1.5"><Label htmlFor="coi-h">Certificate holder name</Label><Input id="coi-h" value={holder} onChange={(e) => setHolder(e.target.value)} data-testid="coi-holder-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="coi-a">Holder address (optional)</Label><Input id="coi-a" value={address} onChange={(e) => setAddress(e.target.value)} data-testid="coi-address-input" /></div>
          <div className="space-y-1.5">
            <Label htmlFor="coi-d">Specific coverage details for this holder (optional)</Label>
            <Textarea id="coi-d" rows={4} maxLength={1200} placeholder="e.g. Certificate holder is listed as additional insured. Project: 123 Main St remodel. Waiver of subrogation applies per written contract." value={details} onChange={(e) => setDetails(e.target.value)} data-testid="coi-details-input" />
            <p className="text-xs text-slate-500">{details.length}/1200 · Printed in the Description of Operations box.</p>
          </div>
          <div className="flex gap-2">
            <Button disabled={!holder.trim()} onClick={() => go(true)} className="bg-blue-700 text-white hover:bg-blue-800" data-testid="coi-download-btn">Download</Button>
            <Button disabled={!holder.trim()} variant="outline" onClick={() => go(false)} data-testid="coi-view-btn">View / print</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
